import axios from 'axios';
import L10n from "@limegreendigital/l10n-js/src";

window.TABS = window.TABS || {};

window.TABS.translation = {
    locale: 'no',
    region: 'no',
    useWindowTranslation: false,
    messages: {},
    init: function () {
        this.bootL10n()

        if (window.isTABStranslations) {
            // Translator already assigned to window
            // Use that translator instead of double loading messages

            if (this.locale !== window.locale || this.region !== window.locale) {
                this.locale = this.region = window.locale
                this.bootL10n()
            }
            this.useWindowTranslation = true;
            return
        }
        const _this = this
        return axios.get(TABS.api.getEndPoint('translations', TABS.api.version, TABS.api.officeId), {
            headers: {
                'Content-Type': 'application/json'
            },
            cache: 'no-cache'
        }).then(response => response.data)
          .then(res => {
              if (_this.locale !== res.locale || _this.region !== res.locale) {
                  _this.locale = _this.region = res.locale
                  _this.bootL10n()
              }
              TABS.translation.messages = res.translations
          });

    },
    bootL10n: function () {
        L10n.boot({
            language: TABS.translation.locale,
            region: TABS.translation.region,
        })
        window.TABS.L10n = L10n
    },
    translate: function (key, values) {
        if (TABS.translation.useWindowTranslation) {
            return window.$t(key, values)
        }
        const messages = TABS.translation.messages[TABS.translation.locale] ?? []
        if (!(key in messages ?? [])) {
            return key
        }
        let translationValue = messages[key]
        if (typeof values !== "object") {
            return translationValue
        }
        Object.keys(values).forEach(function (k, i) {
            let re = new RegExp('\{' + k + '\}');
            translationValue = translationValue.replace(re, values[k])
        })
        return translationValue
    }

}

// API translation helper needs to be assigned to TABS namespace to avoid conflicts
window.TABS.$t = function (key, values) {
    return window.TABS.translation.translate(key, values)
}